import { render, staticRenderFns } from "./CircuitPermissions.vue?vue&type=template&id=1ac4f737&"
import script from "./CircuitPermissions.vue?vue&type=script&lang=js&"
export * from "./CircuitPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports